import { NgModule } from '@angular/core';
import { CommonModule }  from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { MdlModule } from '@angular-mdl/core';

import { TranslateModule } from '../../../../translate/translate.module';

import { SettingsMenuComponent } from './settings-menu.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    TranslateModule,
    MdlModule
  ],
  declarations: [
    SettingsMenuComponent
  ],
  exports: [SettingsMenuComponent]
})
export class SettingsMenuModule { }
